import React, { useState, useEffect } from 'react';

const HeroSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      id: 1,
      tag: '#عروض_اليوم',
      title: 'خصم يصل إلى %50',
      subtitle: 'على جميع المنتجات الإلكترونية',
      image: 'https://images.pexels.com/photos/4158/apple-iphone-smartphone-desk.jpg',
      buttonText: 'تسوق الآن'
    },
    {
      id: 2,
      tag: '#تريند',
      title: 'أحدث الأزياء',
      subtitle: 'مجموعة جديدة من الأزياء العصرية',
      image: 'https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=1200&h=400&fit=crop',
      buttonText: 'اكتشف المزيد'
    },
    {
      id: 3,
      tag: '#لمنزلك',
      title: 'منتجات المنزل',
      subtitle: 'كل ما تحتاجه لمنزل عصري ومريح',
      image: 'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=1200&h=400&fit=crop',
      buttonText: 'تسوق المنزل'
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [slides.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <section className="relative h-96 md:h-[500px] overflow-hidden bg-[#1B1B1F]">
      {/* Slides */}
      <div className="relative w-full h-full">
        {slides.map((slide, index) => (
          <div
            key={slide.id}
            className={`absolute inset-0 transition-opacity duration-500 ${
              index === currentSlide ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <div
              className="w-full h-full bg-cover bg-center relative"
              style={{ backgroundImage: `url(${slide.image})` }}
            >
              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-black/10" />

              {/* Content */}
              <div className="absolute inset-0 flex items-center justify-center text-center text-white">
                <div className="max-w-2xl px-4">
                  <span
                    className="inline-block mb-4 px-4 py-1 rounded-full bg-[#F2B705] text-[#1B1B1F]
                      text-sm font-bold -rotate-2 shadow-md"
                    style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif" }}
                  >
                    {slide.tag}
                  </span>
                  <h1
                    className="text-4xl md:text-6xl font-extrabold mb-4"
                    style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif" }}
                  >
                    {slide.title}
                  </h1>
                  <p className="text-lg md:text-xl mb-8 text-white/90">
                    {slide.subtitle}
                  </p>
                  <button
                    className="inline-flex items-center justify-center whitespace-nowrap rounded-full
                      text-lg font-bold transition-all duration-200
                      bg-[#F2B705] hover:bg-white text-[#1B1B1F] px-8 py-3
                      shadow-lg hover:scale-105
                      focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-black"
                  >
                    {slide.buttonText}
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Navigation Arrows */}
      <button
        aria-label="السابق"
        className="inline-flex items-center justify-center rounded-full w-10 h-10
          absolute left-4 top-1/2 -translate-y-1/2
          bg-white/90 hover:bg-[#F2B705] text-[#1B1B1F] shadow-md transition-colors
          focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-black"
        onClick={prevSlide}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="w-6 h-6"
        >
          <path d="m15 18-6-6 6-6" />
        </svg>
      </button>

      <button
        aria-label="التالي"
        className="inline-flex items-center justify-center rounded-full w-10 h-10
          absolute right-4 top-1/2 -translate-y-1/2
          bg-white/90 hover:bg-[#F2B705] text-[#1B1B1F] shadow-md transition-colors
          focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-black"
        onClick={nextSlide}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="w-6 h-6"
        >
          <path d="m9 18 6-6-6-6" />
        </svg>
      </button>

      {/* Dots Indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex gap-2 z-10">
        {slides.map((_, index) => (
          <button
            key={index}
            aria-label={`الشريحة ${index + 1}`}
            className={`h-2.5 rounded-full transition-all duration-300 ${
              index === currentSlide ? 'w-7 bg-[#F2B705]' : 'w-2.5 bg-white/50 hover:bg-white/80'
            }`}
            onClick={() => setCurrentSlide(index)}
          />
        ))}
      </div>

      {/* حافة ممزّقة تفصل الهيرو عن باقي الصفحة، بنفس روح الملصقات */}
      <svg
        aria-hidden="true"
        className="absolute bottom-0 left-0 w-full h-4 md:h-5"
        preserveAspectRatio="none"
        viewBox="0 0 100 10"
      >
        <path
          d="M0,10 L0,4 L5,8 L10,2 L15,7 L20,3 L25,9 L30,2 L35,6 L40,1 L45,8 L50,3 L55,7 L60,1 L65,9 L70,4 L75,8 L80,2 L85,6 L90,1 L95,7 L100,3 L100,10 Z"
          fill="#F6F5F2"
        />
      </svg>
    </section>
  );
}

export default HeroSection;
